import { ActionFunction } from 'react-router-dom'

import { formDataToArray } from '@utils/actions'
import ApiRoutes from '@utils/api-routes'
import http from '@utils/http'

const deleteScoresAction: ActionFunction = async ({ request }) => {
  const formData = await request.formData()
  const externalIds = formDataToArray(formData.get('scoreIds'))

  if (!externalIds.length) {
    return null
  }

  return http.action.post<DeleteScoresResponse>(ApiRoutes.members.deleteScoresPath(), {
    score_ids: externalIds,
  })
}

export default deleteScoresAction

export type DeleteScoresResponse = {
  failed: string[]
  scores: string[]
}
